// REACT IMPORTS
import { useCallback, useState } from 'react'
// ABSOLUTE IMPORTS
import useIsAUNZ from 'components/hooks/useIsAUNZ'
import { useLibrary } from 'state/useLibrary'
import { HooplaWhite, HooplaWhiteNoR } from 'components/common/icons'
import HeaderV2UI from 'components/browse/skeletonLoaders/MainLayout/HeaderV2/HeaderV2UI'
import { useColorScheme } from 'components/hooks/useColorScheme'

const HeaderV2 = () => {
  const isAUNZ = useIsAUNZ()
  const { isLibraryBrandingEnabled, library, libraryBrandingColor, logoUrl } =
    useLibrary()
  const [isFallbackNeeded, setIsFallbackNeeded] = useState(false)
  const { isDarkMode } = useColorScheme()

  const handleError = useCallback(() => {
    setIsFallbackNeeded(true)
  }, [setIsFallbackNeeded])

  const StaticHooplaLogo = isAUNZ ? HooplaWhiteNoR : HooplaWhite
  const libraryName = library?.name || 'Library'
  let libraryBrandingColorValue = ''
  let alt = 'Hoopla logo'
  let logoUrlValue: string | null = null

  if (isLibraryBrandingEnabled) {
    libraryBrandingColorValue = libraryBrandingColor ?? ''
    alt = `${libraryName} logo`
    logoUrlValue = logoUrl ?? null
  }

  return (
    <HeaderV2UI
      isLibraryBrandingEnabled={isLibraryBrandingEnabled}
      libraryBrandingColor={libraryBrandingColorValue}
      libraryName={libraryName}
      logoUrl={logoUrlValue}
      isDarkMode={isDarkMode}
      isFallbackNeeded={isFallbackNeeded}
      onError={handleError}
      alt={alt}
      StaticHooplaLogo={StaticHooplaLogo}
    />
  )
}

export default HeaderV2
